exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n    background-color: #c6d7f2;\n}\n", ""]);

// exports
